function gettable5(state){
    let result = [];
    let sourceName = "";
    let value;
    let j = 0;

    for(let key in state.objects.ndt){
        sourceName = `Источник ${j+1} (труба от вращающейся печи "${state.objects.ndt[key].name.value}")`;
        for(let i = 0; i < criticalNDT.length; i++){
            if(state.objects.ndt[key].ndtres[criticalNDT[i]] !== "4"){
                if(state.objects.ndt[key].ndtres[criticalNDT[i]] === "2"){
                    value = criticalNDTvalue[criticalNDT[i]][getNDTValueCode(state.objects, key, criticalNDT[i])].substr(1);
                }
                else {
                    value = state.objects.ndt[key].ndtValue[criticalNDT[i]].value;
                } 
                result.push([sourceName, "", "", criticalNDTtexts[criticalNDT[i]], classNDTdanger[criticalNDT[i]], value, "", ""]);
            } 
        }
        j++;
    } 

    return result;
} 

const criticalNDT = ["ndt8", "ndt10", "ndt11", "ndt12", "ndt13"];

const criticalNDTtexts = {
    ndt8: 'Пыль неорганическая с содержание SiO2 менее 20%',
    ndt10: 'NOx',
    ndt11: 'NH3',
    ndt12: 'SO2',
    ndt13: 'CO'
}

const criticalNDTvalue = {
    ndt8: {
        "1": '⩽25',
        "2": '⩽50',
        "3": '⩽500',
        "4": '⩽1000'
    } ,
    ndt10: {
        "1": '⩽500',
        "2": '⩽800',
        "3": '⩽500'
    },
    ndt11: {
        "1": '⩽50'    
    },
    ndt12: {
        "1":'⩽400',
    } ,
    ndt13: {
        "1": '⩽600'
    }
}



const classNDTdanger = {
    ndt8: 3,
    ndt10: 3,
    ndt11: 4,
    ndt12: 3,
    ndt13: 4
}


export default gettable5

